/*
 * RipperToys — Tic Tac Toe (minimax AI)
 * Markup comes from snippets/rt-tic-tac-toe.liquid. Every [data-rt-ttt] root on
 * the page is initialised automatically; copy is read from its data-copy-* attributes.
 * ES5 only — no globals.
 */
(function () {
  var LINES = [[0, 1, 2], [3, 4, 5], [6, 7, 8], [0, 3, 6], [1, 4, 7], [2, 5, 8], [0, 4, 8], [2, 4, 6]];
  var AI_DELAY = 380;

  function emptyBoard() {
    return [null, null, null, null, null, null, null, null, null];
  }

  function isFull(board) {
    for (var i = 0; i < 9; i++) {
      if (!board[i]) return false;
    }
    return true;
  }

  function winningLine(board, player) {
    for (var i = 0; i < LINES.length; i++) {
      var line = LINES[i];
      if (board[line[0]] === player && board[line[1]] === player && board[line[2]] === player) return line;
    }
    return null;
  }

  function minimax(board, aiTurn) {
    if (winningLine(board, 'O')) return 10;
    if (winningLine(board, 'X')) return -10;
    if (isFull(board)) return 0;
    var best = aiTurn ? -Infinity : Infinity;
    for (var i = 0; i < 9; i++) {
      if (!board[i]) {
        board[i] = aiTurn ? 'O' : 'X';
        var score = minimax(board, !aiTurn);
        board[i] = null;
        best = aiTurn ? Math.max(best, score) : Math.min(best, score);
      }
    }
    return best;
  }

  function bestMove(board) {
    var best = -Infinity;
    var move = -1;
    for (var i = 0; i < 9; i++) {
      if (!board[i]) {
        board[i] = 'O';
        var score = minimax(board, false);
        board[i] = null;
        if (score > best) { best = score; move = i; }
      }
    }
    return move;
  }

  function init(root) {
    if (root.getAttribute('data-rt-ttt-ready')) return;
    root.setAttribute('data-rt-ttt-ready', 'true');

    var copy = {
      awaiting: root.getAttribute('data-copy-awaiting'),
      thinking: root.getAttribute('data-copy-thinking'),
      win: root.getAttribute('data-copy-win'),
      loss: root.getAttribute('data-copy-loss'),
      draw: root.getAttribute('data-copy-draw')
    };
    var boardEl = root.querySelector('[data-rt-ttt-board]');
    var cells = root.querySelectorAll('[data-rt-ttt-cell]');
    var statusEl = root.querySelector('[data-rt-ttt-status]');
    var resetBtn = root.querySelector('[data-rt-ttt-reset]');
    var scoreEls = {
      x: root.querySelector('[data-rt-ttt-score="x"]'),
      d: root.querySelector('[data-rt-ttt-score="d"]'),
      o: root.querySelector('[data-rt-ttt-score="o"]')
    };

    var board = emptyBoard();
    var scores = { x: 0, d: 0, o: 0 };
    var over = false;
    var aiTimer = null;

    function render() {
      for (var i = 0; i < cells.length; i++) {
        var mark = board[i];
        cells[i].textContent = mark || '';
        cells[i].className = 'rt__ttt-cell' + (mark ? ' rt__ttt-cell--taken rt__ttt-cell--' + mark.toLowerCase() : '');
        cells[i].setAttribute('aria-label', 'Cell ' + (i + 1) + ', ' + (mark || 'empty'));
        // aria-disabled (not disabled) so keyboard focus isn't dropped mid-game.
        cells[i].setAttribute('aria-disabled', mark || over || aiTimer !== null ? 'true' : 'false');
      }
    }

    function setStatus(msg, isWin) {
      statusEl.textContent = msg;
      statusEl.className = 'rt__ttt-status' + (isWin ? ' rt__ttt-status--win' : '');
    }

    function setResetActive(active) {
      resetBtn.className = 'rt__ttt-reset' + (active ? ' rt__ttt-reset--active' : '');
    }

    function drawLine(line) {
      var from = cells[line[0]].getBoundingClientRect();
      var to = cells[line[2]].getBoundingClientRect();
      var box = boardEl.getBoundingClientRect();
      var x1 = from.left + from.width / 2 - box.left;
      var y1 = from.top + from.height / 2 - box.top;
      var dx = to.left + to.width / 2 - box.left - x1;
      var dy = to.top + to.height / 2 - box.top - y1;
      var length = Math.sqrt(dx * dx + dy * dy);
      var angle = Math.atan2(dy, dx) * 180 / Math.PI;
      var el = document.createElement('div');
      el.className = 'rt__ttt-win-line';
      el.setAttribute('aria-hidden', 'true');
      el.style.cssText = 'width:' + length + 'px;left:' + x1 + 'px;top:' + y1 + 'px;transform:rotate(' + angle + 'deg)';
      boardEl.appendChild(el);
    }

    function clearLines() {
      var lines = boardEl.querySelectorAll('.rt__ttt-win-line');
      for (var i = 0; i < lines.length; i++) lines[i].parentNode.removeChild(lines[i]);
    }

    // result: 'x' | 'o' | 'd'
    function endGame(result, line) {
      over = true;
      if (line) drawLine(line);
      scores[result]++;
      scoreEls[result].textContent = scores[result];
      setStatus(result === 'x' ? copy.win : result === 'o' ? copy.loss : copy.draw, result === 'x');
      setResetActive(true);
      render();
    }

    // Returns true when the move ended the game.
    function checkEnd(player) {
      var line = winningLine(board, player);
      if (line) { endGame(player.toLowerCase(), line); return true; }
      if (isFull(board)) { endGame('d', null); return true; }
      return false;
    }

    function aiTurn() {
      aiTimer = null;
      var move = bestMove(board);
      if (move < 0) return;
      board[move] = 'O';
      render();
      if (!checkEnd('O')) setStatus(copy.awaiting);
    }

    function play(i) {
      // Input is locked while the AI is thinking, so the player can't sneak in a second move.
      if (over || aiTimer !== null || board[i]) return;
      board[i] = 'X';
      render();
      if (checkEnd('X')) return;
      setStatus(copy.thinking);
      aiTimer = setTimeout(aiTurn, AI_DELAY);
      render();
    }

    function reset() {
      if (aiTimer !== null) {
        clearTimeout(aiTimer);
        aiTimer = null;
      }
      board = emptyBoard();
      over = false;
      clearLines();
      render();
      setStatus(copy.awaiting);
      setResetActive(false);
    }

    boardEl.addEventListener('click', function (e) {
      var target = e.target;
      while (target && target !== boardEl && !target.hasAttribute('data-rt-ttt-cell')) target = target.parentNode;
      if (!target || target === boardEl) return;
      play(parseInt(target.getAttribute('data-rt-ttt-cell'), 10));
    });
    resetBtn.addEventListener('click', reset);

    render();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-rt-ttt]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
